import React, { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import {
	createSearchParams,
	useNavigate,
	useOutletContext,
	useSearchParams,
} from 'react-router-dom';
import { TextHighlighter } from '../shared/textBold';
import { decodeName, encodeName } from '../utils';
import { useSelector } from 'react-redux';
import { AllData } from './allData';
import { InvData } from './invData';
import { ClientData } from './clientData';
import { VendorData } from './vendorData';
import { ContData } from './contData';
import { FilterInvoiceList } from './filterInvoice';
import { FilterContractList } from './filterContract';

export const GInvoicesListingData = () => {
	const [tabInd, settabInd] = useState(0)
	const Data = useSelector((state) => state.auth);
	const { paginatedData, getpageSizeCall, setpageSizeCall } = useOutletContext();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	function handleNavigate(obj) {
		const encodedClientName = encodeName(
			decodeName(searchParams.get('client_name'))
		);
		const encodedVendorName = encodeName(
			decodeName(searchParams.get('vendor_name'))
		);
		const encodeInvoiceName = encodeName(obj.fname);

		navigate({
			pathname: '/my-annotations',
			search: createSearchParams({
				client_id: searchParams.get('client_id'),
				client_name: encodedClientName,
				client_list_page_no: searchParams.get('client_list_page_no'),
				client_list_sort_key: searchParams.get('client_list_sort_key'),
				client_list_sort_order: searchParams.get('client_list_sort_order'),

				vendor_id: searchParams.get('vendor_id'),
				vendor_name: encodedVendorName,
				vendor_list_page_no: searchParams.get('vendor_list_page_no'),
				vendor_list_sort_key: searchParams.get('vendor_list_sort_key'),
				vendor_list_sort_order: searchParams.get('vendor_list_sort_order'),
				category_name: encodeName(
					decodeName(searchParams.get('category_name'))
				),
				category_id: encodeName(decodeName(searchParams.get('category_id'))),

				invoice_id: obj._id,
				invoice_name: encodeInvoiceName,
				invoice_list_page_no: searchParams.get('invoice_list_page_no'),
				invoice_list_sort_key: searchParams.get('invoice_list_sort_key'),
				invoice_list_sort_order: searchParams.get('invoice_list_sort_order'),
			}).toString(),
		});
	}
	console.log(tabInd, "tabInd");
	

	
	return (
		<div className="space-y-4">

			<div>
				<Tabs selectedIndex={tabInd} onSelect={(index) => settabInd(index)}>
			<TabList>
				<span className='inline-block font-bold mr-4'>Search Results:</span>
				<Tab>All</Tab>
				<Tab>Invoices {paginatedData?.invoice_count ? `(${paginatedData?.invoice_count})` : ''}</Tab>
				<Tab>Contracts {paginatedData?.contract_count ? `(${paginatedData?.contract_count})` : ''}</Tab>
				<Tab>Clients {paginatedData?.client_count ? `(${paginatedData?.client_count})` : ''}</Tab>
				<Tab>Vendors {paginatedData?.vendor_count ? `(${paginatedData?.vendor_count})` : ''}</Tab>
			</TabList>

			<TabPanel className='pt-0'>
				<AllData data={paginatedData} settabInd={settabInd} />
			</TabPanel>
			<TabPanel className='pt-0'>
				{/* <InvData data={paginatedData?.invoice} count={paginatedData?.invoice_count} /> */}
				<FilterInvoiceList data={paginatedData?.invoice} count={paginatedData?.invoice_count} getpageSizeCall={getpageSizeCall} setpageSizeCall={setpageSizeCall} />
			</TabPanel>
			<TabPanel className='pt-0'>
				<FilterContractList data={paginatedData?.contract} count={paginatedData?.contract_count} getpageSizeCall={getpageSizeCall} setpageSizeCall={setpageSizeCall} />
			</TabPanel>
			<TabPanel className='pt-0'>
				<ClientData data={paginatedData?.client} count={paginatedData?.client_count} getpageSizeCall={getpageSizeCall} setpageSizeCall={setpageSizeCall} />
			</TabPanel>
			<TabPanel className='pt-0'>
				<VendorData data={paginatedData?.vendor} count={paginatedData?.vendor_count} getpageSizeCall={getpageSizeCall} setpageSizeCall={setpageSizeCall} />
			</TabPanel>
		</Tabs>
			</div>


			{/* <div className="text-center py-12">
					<div className="text-gray-500 text-lg mb-2">No results found</div>
					<div className="text-gray-400 text-sm">
						Try adjusting your search terms or filters
					</div>
				</div> */}

		</div>
	);
};
